<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar cufds</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <p>Se procedera a registrar un nuevo CUFD para el punto de venta actual.</p>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            {{ cufd.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import { getAccessToken } from '@/accessToken';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        tipos: [],
        cufd: {
          id: null,
          codigoPuntoVenta: 0,
          codigoSucursal: 0,
        },
        apikeytoken: null,
      };
    },
    components: {},
    watch: {},
    methods: {
      async openmodal(item, codigopunto, numero_sucursal) {
        this.msg = '';
        this.dialog = true;
        this.cufd.id = null;
        this.cufd.codigoPuntoVenta = parseInt(codigopunto);
        this.cufd.codigoSucursal = parseInt(numero_sucursal);
        if (item) {
          this.cufd.id = item.id;
          this.cufd.codigoPuntoVenta = item.codigoPuntoVenta;
          this.cufd.codigoSucursal = item.codigoSucursal;
        }
        await this.obtenerToknFactura();
      },
      save() {
        this.msg = '';
        //if (!this.cufd.codigoPuntoVenta) this.msg = 'No hay punto de venta.';
        //if (!this.cufd.codigoSucursal) this.msg = 'No hay codigo sucursal';
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        if (this.cufd.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cufds`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.apikeytoken,
          },
          data: this.cufd,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('pventanew::', data);
            if (data.codigo) {
              data.estado = 1;
              vue.msg = `Registrado, ID:${data.id}`;
              vue.$emit('newregcufd', data);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;

            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },

      async obtenerToknFactura() {
        let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
  };
</script>
